function describeReason() {
  return "No reason for empty parent issue";
}

export default describeReason;
